import { Icon, IconName, Tooltip } from '@usealloy/component-library';
import React from 'react';
import styled, { css } from 'styled-components';

export const FieldContainer = styled.div<{
  maxWidth?: string;
  noTruncate?: boolean;
  noPadding?: boolean;
}>`
  ${({ noPadding }) => (!noPadding && css`padding: var(--cl-space-2);`)}
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${({ maxWidth }) => (maxWidth && css`max-width: ${maxWidth}`)}
  ${({ noTruncate }) => (noTruncate && css`min-width: fit-content;`)}
`;

export const FieldName = styled.div`
  font-size: 14px;
  line-height: var(--cl-line-height-4);
  color: #7f7f7f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

export const FieldDetail = styled.div<{
  wrap?: boolean;
}>`
  ${({ wrap }) => (!wrap && css`
    white-space: nowrap;
    `)}
    overflow: hidden;
    text-overflow: ellipsis;
`;

type FieldProps = React.PropsWithChildren<{
  fieldName: string;
  maxWidth?: string;
  noTruncate?: boolean;
  noPadding?: boolean;
  wrap?: boolean;
  tooltip?: string;
}>;

export const Field: React.FC<FieldProps> = ({
  children, fieldName, maxWidth, noTruncate, noPadding, wrap, tooltip,
}) => (
  <FieldContainer
    noTruncate={noTruncate}
    noPadding={noPadding}
    maxWidth={maxWidth}
    data-field-name={fieldName.toLowerCase().replace(/\s+/g, '-')}
  >
    <FieldName>
      {fieldName}
      {tooltip && (
        <Tooltip content={tooltip}>
          <Icon icon={IconName.Info} size="small" style={{ marginLeft: '5px' }} />
        </Tooltip>
      )}
    </FieldName>
    <FieldDetail wrap={wrap}>{children}</FieldDetail>
  </FieldContainer>
);
